// Постоянные для ingredients-reducer
export const SET_INGREDIENTS_SUCCESS: "SET_INGREDIENTS_SUCCESS" =
  "SET_INGREDIENTS_SUCCESS";
export const SET_INGREDIENTS_REQUEST: "SET_INGREDIENTS_REQUEST" =
  "SET_INGREDIENTS_REQUEST";
export const SET_INGREDIENTS_ERROR: "SET_INGREDIENTS_ERROR" =
  "SET_INGREDIENTS_ERROR";
export const SET_CURRENT_INGREDIENT: "SET_CURRENT_INGREDIENT" =
  "SET_CURRENT_INGREDIENT";
export const REMOVE_CURRENT_INGREDIENT: "REMOVE_CURRENT_INGREDIENT" =
  "REMOVE_CURRENT_INGREDIENT";
export const SHOW_INGREDIENTS_MODAL: "SHOW_INGREDIENTS_MODAL" =
  "SHOW_INGREDIENTS_MODAL";
export const HIDE_INGREDIENTS_MODAL: "HIDE_INGREDIENTS_MODAL" =
  "HIDE_INGREDIENTS_MODAL";
// __________________________________

// Постоянные для constructor-reducer
export const ADD_BUN: "ADD_BUN" = "ADD_BUN";
export const ADD_INGREDIENT: "ADD_INGREDIENT" = "ADD_INGREDIENT";
export const MOVE_INGREDIENT: "MOVE_INGREDIENT" = "MOVE_INGREDIENT";
export const REMOVE_ITEM: "REMOVE_ITEM" = "REMOVE_ITEM";
export const ADD_TO_INGREDIENTS_MAP: "ADD_TO_INGREDIENTS_MAP" =
  "ADD_TO_INGREDIENTS_MAP";
export const ADD_TO_BUN_MAP: "ADD_TO_BUN_MAP" = "ADD_TO_BUN_MAP";

export const POST_ORDER_SUCCESS: "POST_ORDER_SUCCESS" = "POST_ORDER_SUCCESS";
export const POST_ORDER_REQUEST: "POST_ORDER_REQUEST" = "POST_ORDER_REQUEST";
export const POST_ORDER_ERROR: "POST_ORDER_ERROR" = "POST_ORDER_ERROR";

export const CLEAR_CONSTRUCTOR: "CLEAR_CONSTRUCTOR" = "CLEAR_CONSTRUCTOR";
// __________________________________

// Modal special
export const SHOW_MODAL: "SHOW_MODAL" = "SHOW_MODAL";
export const HIDE_MODAL: "HIDE_MODAL" = "HIDE_MODAL";
// __________________________________

// Постоянные для user-reducer
export const REQUEST: "REQUEST" = "REQUEST";
export const REQUEST_ERROR: "REQUEST_ERROR" = "REQUEST_ERROR";
export const REQUEST_SUCCESS: "REQUEST_SUCCESS" = "REQUEST_SUCCESS";
// __________________________________

// Постоянные для orders-reducer
export const ORDERS_REQUEST: "ORDERS_REQUEST" = "ORDERS_REQUEST";
export const ORDERS_REQUEST_ERROR: "ORDERS_REQUEST_ERROR" = "ORDERS_REQUEST_ERROR";
export const ORDERS_REQUEST_SUCCESS: "ORDERS_REQUEST_SUCCESS" = "ORDERS_REQUEST_SUCCESS";
// __________________________________

// Для WS
export const WS_CONNECTION_START: 'WS_CONNECTION_START' = 'WS_CONNECTION_START';
export const WS_CONNECTION_PROFILE_ORDERS_START: 'WS_CONNECTION_PROFILE_ORDERS_START' = 'WS_CONNECTION_PROFILE_ORDERS_START';

export const WS_USER_CONNECTION_SUCCESS: 'WS_USER_CONNECTION_SUCCESS'  = 'WS_USER_CONNECTION_SUCCESS';
export const WS_CONNECTION_SUCCESS: 'WS_CONNECTION_SUCCESS'  = 'WS_CONNECTION_SUCCESS';

export const WS_USER_CONNECTION_ERROR: 'WS_USER_CONNECTION_ERROR' = 'WS_USER_CONNECTION_ERROR';
export const WS_CONNECTION_ERROR: 'WS_CONNECTION_ERROR' = 'WS_CONNECTION_ERROR';

export const WS_USER_CONNECTION_CLOSED: 'WS_USER_CONNECTION_CLOSED' = 'WS_USER_CONNECTION_CLOSED';
export const WS_CONNECTION_CLOSED: 'WS_CONNECTION_CLOSED' = 'WS_CONNECTION_CLOSED';

export const WS_GET_ORDERS: 'WS_GET_ORDERS' = 'WS_GET_ORDERS';
export const WS_GET_USER_ORDERS: 'WS_GET_USER_ORDERS' = 'WS_GET_USER_ORDERS';
// __________________________________
